module.exports = __webpack_public_path__ + "static/media/yt-leave-cab.0f1641fe.mov";